<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-20 md-xsmall-size-40">
      <br />
      <br />
      <product-card header-animation="false">
        <div slot="imageHeader">
          <div
            class="clickable icon-add"
            @click="referToInputPickFile"
            style="z-index: 100"
          >
            <md-icon class="md-success">photo_camera</md-icon>
          </div>
          <input
            id="iconImage"
            @change="addImg"
            type="file"
            accept="image/png, image/jpeg"
            ref="inputFile"
            style="display: none"
          />
          <img
            @dbclick="referToInputPickFile"
            class="img"
            :src="
              form.avatar
                ? form.avatar.url
                  ? form.avatar.url
                  : defaultAvatar
                : defaultAvatar
            "
          />
          <div class="md-layout-item" v-show="progress !== 100">
            <md-progress-bar
              class="md-primary"
              :md-value="progress"
            ></md-progress-bar>
          </div>
        </div>
        <h4 slot="title" class="title">
          <p>
            {{ form.permission === "Cộng tác viên" ? "CTV" : "Nhân viên" }}:
            {{ form.name }}
          </p>
          <p>Mã nhân viên: {{ form.employeeCode }}</p>
          <p v-for="(item, index) in listRank" :key="index">
            <span
              v-if="
                item.affiliateRates === newRate &&
                  form.permission === 'Cộng tác viên' &&
                  !isAddUser
              "
              ><i class="far fa-star"></i> Hạng: {{ item.label }}</span
            >
          </p>
        </h4>
        <div
          class="md-layout-item md-size-100"
          slot="description"
          v-if="!isAddUser"
        >
          <ValidationObserver v-slot="{ handleSubmit }">
            <form
              @submit.prevent="handleSubmit(resetPassword)"
              style="text-align: center"
            >
              <md-field>
                <label>Mật khẩu mới:</label>
                <md-input required v-model="newPassword" type="text"></md-input>
              </md-field>
              <md-button
                class="md-success md-dense"
                type="submit"
                :disabled="flagLoading"
                >Đổi mật khẩu</md-button
              >
            </form>
          </ValidationObserver>
        </div>
      </product-card>
    </div>
    <div class="md-layout-item md-size-80 md-xsmall-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="title">
            <div class="navbar">
              <a @click="close(form.employeeCode)"
                ><i class="fas fa-arrow-left"></i
              ></a>
              <a
                v-bind:class="{ active: tabActive === 'info' }"
                @click="tabActive = 'info'"
                ><i class="fas fa-info-circle"></i>Thông tin</a
              >
              <a
                v-bind:class="{ active: tabActive === 'history' }"
                @click="tabActive = 'history'"
                v-if="form.permission === 'Cộng tác viên' && !isAddUser"
                ><i class="fas fa-history"></i> Lịch sử giao dịch</a
              >
              <a
                v-bind:class="{ active: tabActive === 'recharge' }"
                @click="tabActive = 'recharge'"
                v-if="form.permission === 'Cộng tác viên' && !isAddUser"
                ><i class="fas fa-plus-circle"></i> Nạp tiền</a
              >
              <a
                v-bind:class="{ active: tabActive === 'deduct' }"
                @click="tabActive = 'deduct'"
                v-if="form.permission === 'Cộng tác viên' && !isAddUser"
                ><i class="fas fa-minus-circle"></i> Trừ tiền</a
              >
              <a
                v-show="!isAddUser"
                @click="confirmBanUser(userSelected)"
                style="float: right"
              >
                <i class="fas fa-key" style="color: #bf2626"></i>
                {{ form.isBanned ? "Mở khóa tài khoản" : "Khóa tài khoản" }}
              </a>
            </div>
            <span style="color: red" v-show="form.isBanned">
              <i class="fas fa-lock"></i>
            </span>
          </div>
        </md-card-header>
        <md-card-content>
          <ValidationObserver
            v-slot="{ handleSubmit }"
            v-if="tabActive === 'info'"
          >
            <form @submit.prevent="handleSubmit(submit)">
              <div class="md-layout">
                <div class="md-layout-item md-size-50 md-xsmall-size-100">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-60 md-xsmall-size-100">
                      <md-field>
                        <label>Tên nhân viên:</label>
                        <md-input
                          v-model="form.name"
                          required
                          @change="isHaveAnyChange = true"
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-40 md-xsmall-size-100">
                      <md-field>
                        <label>Mã nhân viên:</label>
                        <md-input
                          v-model="form.employeeCode"
                          required
                          @change="isHaveAnyChange = true"
                          :disabled="!isAddUser"
                        ></md-input>
                      </md-field>
                    </div>
                  </div>
                  <div class="md-layout-item md-size-100">
                    <md-field>
                      <label>Email:</label>
                      <md-input
                        v-model="form.email"
                        type="email"
                        @change="isHaveAnyChange = true"
                        :disabled="!isAddUser"
                        required
                      ></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-100">
                    <md-field>
                      <label>Vai trò:</label>
                      <md-select
                        v-model="form.permission"
                        required
                        @md-selected="isHaveAnyChange = true"
                        :disabled="!isAddUser"
                      >
                        <md-option value="Cộng tác viên"
                          >Cộng tác viên</md-option
                        >
                        <md-option value="Nhân viên bán hàng"
                          >Nhân viên bán hàng</md-option
                        >
                      </md-select>
                    </md-field>
                  </div>
                  <div
                    class="md-layout-item md-size-100"
                    v-if="form.permission === 'Cộng tác viên'"
                  >
                    <md-field>
                      <label>Số dư tài khoản:</label>
                      <md-input
                        v-model="form.deposit"
                        @change="isHaveAnyChange = true"
                        type="number"
                        min="0"
                        disabled
                      ></md-input>
                    </md-field>
                  </div>
                  <div
                    class="md-layout-item md-size-100"
                    v-if="form.permission === 'Cộng tác viên' && isAddUser"
                  >
                    <md-field>
                      <label>Hạng cộng tác viên</label>
                      <!-- <md-input
                        v-model="form.affiliateRate"
                        @change="isHaveAnyChange = true"
                        pattern="^[0-9].*$"
                        title="Chỉ cho phép nhập số"
                        required
                      ></md-input> -->
                      <md-select v-model="form.affiliateRate">
                        <md-option
                          v-for="(item, index) in listRank"
                          :key="index"
                          :value="item.affiliateRates"
                          >{{ item.label }} ({{ item.affiliateRates }}%)
                        </md-option>
                      </md-select>
                    </md-field>
                  </div>
                </div>
                <div class="md-layout-item">
                  <div class="md-layout-item md-size-100">
                    <md-field>
                      <label>Địa chỉ:</label>
                      <md-input
                        v-model="form.address"
                        @change="isHaveAnyChange = true"
                      ></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-100">
                    <md-field>
                      <label>Số điện thoại:</label>
                      <md-input
                        v-model="form.phone"
                        @change="isHaveAnyChange = true"
                        pattern="^[0-9]*$"
                        title="Số điện thoại không chứa ký tự đặc biệt"
                      ></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-layout md-size-100">
                    <div class="md-layout-item md-size-50">
                      <md-field>
                        <label>Ngày sinh:</label>
                        <md-input
                          v-model="form.dateOfBith"
                          @change="isHaveAnyChange = true"
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-50">
                      <md-field>
                        <label>Giới tính:</label>
                        <md-select
                          v-model="form.gender"
                          @md-selected="isHaveAnyChange = true"
                        >
                          <md-option value="male">Nam</md-option>
                          <md-option value="female">Nữ</md-option>
                        </md-select>
                      </md-field>
                    </div>
                  </div>
                  <div class="md-layout-item md-size-100" v-if="isAddUser">
                    <md-field>
                      <label>Mật khẩu:</label>
                      <md-input
                        required
                        v-model="password"
                        type="text"
                      ></md-input>
                    </md-field>
                  </div>
                  <div
                    class="md-layout-item"
                    v-if="form.permission === 'Cộng tác viên' && !isAddUser"
                  >
                    <md-button
                      class="md-success md-dense"
                      @click="showDialogChangeRank = true"
                    >
                      Đổi hạng
                    </md-button>
                  </div>
                </div>
              </div>
              <div class="formActions">
                <!-- <md-button
                      class="md-info"
                      @click="selectProduct"
                    >
                      Chọn sản phẩm
                    </md-button>-->
                <md-button
                  class="md-success"
                  type="submit"
                  v-show="isHaveAnyChange || isAddUser"
                  :disabled="flagLoading"
                  >{{ isAddUser ? "Tạo tài khoản" : "Chỉnh sửa" }}</md-button
                >
              </div>
            </form>
          </ValidationObserver>
          <div v-if="form.permission === 'Cộng tác viên' && !isAddUser">
            <transactions-history
              v-if="tabActive === 'history'"
              :user="userSelected"
              :functions="functions"
              :db="db"
            />
            <recharge
              v-show="tabActive === 'recharge'"
              :user="userSelected"
              :functions="functions"
              @recharge="recharge"
            />
            <deduct
              v-show="tabActive === 'deduct'"
              :user="userSelected"
              :functions="functions"
              @deduct="deduct"
            />
          </div>
        </md-card-content>
      </md-card>
      <md-card
        v-if="form.permission === 'Cộng tác viên'"
        v-show="tabActive === 'info'"
      >
        <md-card-content>
          <div class="w-full flex-sb flex-m">
            <div class="text-up font-bold">Danh sách sản phẩm</div>
            <md-button
              class="md-success md-dense"
              @click="isAddProducts = true"
            >
              Thêm sản phẩm
            </md-button>
          </div>
          <md-table
            :value="form.listProducts"
            class="table-products table-hover"
            table-header-color="green"
            md-fixed-header
            :md-height="300"
          >
            <md-table-row
              slot="md-table-row"
              slot-scope="{ item }"
              @click="editItem(item)"
              class="clickable"
            >
              <md-table-cell
                md-label="Mã sản phầm"
                class="table-cell"
                align="left"
              >
                {{ item.id }}
              </md-table-cell>
              <md-table-cell
                md-label="Tên sản phẩm"
                class="table-cell"
                align="left"
              >
                {{ item.name }}
              </md-table-cell>
              <md-table-cell md-label="Xóa" class="table-cell" align="center">
                <md-button
                  class="md-just-icon md-danger md-simple"
                  @click.stop="removeProduct(item)"
                >
                  <md-icon>close</md-icon>
                  <md-tooltip>Xóa sản phẩm</md-tooltip>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
          <!-- <div
            class="md-layout-item md-size-20 product"
            :key="index"
            v-for="(item, index) in form.listProducts"
          >
            <i
              class="far fa-times-circle remove clickable"
              @click="removeProduct(index)"
            ></i>
            <div>Tên: {{ item.name }}</div>
          </div> -->
        </md-card-content>
      </md-card>
      <md-dialog :md-active.sync="showDialogChangeRank">
        <md-dialog-title>Thay đổi hạng cộng tác viên</md-dialog-title>
        <div class="bodyDialog">
          <!-- <md-textarea v-model="policyPartners"></md-textarea> -->
          <md-field>
            <label>Hạng Cộng tác viên</label>
            <md-select v-model="newRate">
              <md-option
                v-for="(item, index) in listRank"
                :key="index"
                :value="item.affiliateRates"
              >
                {{ item.label }} ({{ item.affiliateRates }}%)
              </md-option>
            </md-select>
          </md-field>
        </div>
        <md-dialog-actions>
          <md-button
            class="md-danger md-dense"
            @click="showDialogChangeRank = false"
          >
            Đóng
          </md-button>
          <md-button class="md-success md-dense" @click="confirmChangeRank">
            Lưu
          </md-button>
        </md-dialog-actions>
      </md-dialog>
      <modal-add-products
        :key="isAddProducts"
        v-if="isAddProducts"
        @smallAlertModalHide="smallAlertModalHide"
        :listProductsSelected="form.listProducts"
      ></modal-add-products>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { ProductCard } from "@/components";
import Swal from "sweetalert2";
import firebase from "@/services/firebase-init.js";
export default {
  components: {
    ProductCard,
    ModalAddProducts: () => import("./ModalAddProducts.vue"),
    TransactionsHistory: () => import("./TransactionsHistory"),
    Recharge: () => import("./Recharge.vue"),
    Deduct: () => import("./Deduct"),
  },
  props: ["userSelected", "isAddUser"],
  created() {
    if (!this.isAddUser) {
      this.form = JSON.parse(JSON.stringify(this.userSelected.data));
      if (!this.form.avatar) {
        this.$set(this.form, "avatar", {
          url: "",
          ref: "",
        });
      }
    }
    this.functions = firebase.functions();
    this.db = firebase.firestore();
    var storage = firebase.storage();
    this.storageRef = storage.ref("User");
    if (this.form.permission === "Cộng tác viên" || this.isAddUser) {
      var bits = localStorage.getItem("bits");
      this.db
        .collection("--stats--")
        .doc(process.env.VUE_APP_PARTNER_POLICY + bits)
        .get()
        .then((doc) => {
          if (doc.exists) {
            this.listRank = doc.data().listRank;
          }
        });
    }
    if (this.form.permission === "Cộng tác viên" && !this.isAddUser) {
      var bits = localStorage.getItem("bits");
      this.db
        .collection("--stats--")
        .doc(process.env.VUE_APP_AFFILIATE_RATES + bits)
        .get()
        .then((doc) => {
          if (doc.exists) {
            this.newRate = doc.data().rates[`${this.form.employeeCode}`];
          }
        });
    }
  },
  data() {
    return {
      newRate: null,
      showDialogChangeRank: false,
      isAddProducts: false,
      isHaveAnyChange: false,
      isResetPass: false,
      password: "",
      newPassword: "",
      progress: 100,
      storageRef: {},
      db: {},
      functions: {},
      form: {
        affiliateRate: 0,
        listProductId: [],
        deposit: 0,
        permission: "Nhân viên bán hàng",
        isBanned: false,
        dateOfBith: "",
        gender: "",
        avatar: {
          url: "",
          ref: "",
        },
        listProducts: [],
      },
      tabActive: "info",
      defaultAvatar: "./img/default-avatar.png",
      listRank: [],
    };
  },
  computed: {
    ...mapGetters(["flagLoading"]),
  },
  methods: {
    resetPassword() {
      Swal.fire({
        title: "Đổi mật khẩu",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "OK",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("FLAG_LOADING", true);
          let addNewUser = this.functions.httpsCallable(
            process.env.VUE_APP_RESET_PASSWORD_FUNC
          );
          addNewUser({
            email: this.form.email,
            newPassword: this.newPassword,
          })
            .then((result) => {
              if (result.success === false) {
                this.$store.dispatch("FLAG_LOADING", false);
                this.$messageError("Có lỗi, Thử lại!");
              } else {
                this.$store.dispatch("FLAG_LOADING", false);
                this.$messageSuccess("Đổi mật khẩu thành công");
              }
            })
            .catch((error) => {
              this.$store.dispatch("FLAG_LOADING", false);
              this.$messageError(error.message);
            });
        }
      });
    },
    confirmBanUser(item) {
      Swal.fire({
        title: !item.data.isBanned
          ? "Khóa tài khoản: " + item.data.employeeCode
          : "Mở khóa tài khoản: " + item.data.employeeCode,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "OK",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("FLAG_LOADING", true);
          !item.data.isBanned ? this.banUser(item) : this.enableUser(item);
        }
      });
    },
    banUser(item) {
      let banThisUser = this.functions.httpsCallable(
        process.env.VUE_APP_DISABLE_USER_FUNC
      );
      banThisUser({
        email: item.data.email,
      })
        .then((result) => {
          if (result.success === false) {
            this.$store.dispatch("FLAG_LOADING", false);
            this.$messageError("Có lỗi, Thử lại!");
          } else {
            this.updateBandUser(item);
            this.$messageSuccess("Đã khóa tài khoản");
          }
        })
        .catch((error) => {
          this.$store.dispatch("FLAG_LOADING", false);
          console.log(error);
          this.$messageError("Có lỗi, Thử lại!");
        });
    },
    enableUser(item) {
      let enableTHisUser = this.functions.httpsCallable(
        process.env.VUE_APP_ENABLE_USER_FUNC
      );
      enableTHisUser({
        email: item.data.email,
      })
        .then((result) => {
          if (result.success === false) {
            this.$store.dispatch("FLAG_LOADING", false);
            this.$messageError("Có lỗi, Thử lại!");
          } else {
            this.updateEnableUser(item);
            this.$messageSuccess("Đã mở khóa tài khoản");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$messageError("Có lỗi, Thử lại!");
        });
    },
    updateBandUser(item) {
      item.data.isBanned = true;
      this.updateUser(item);
    },
    updateEnableUser(item) {
      item.data.isBanned = false;
      this.updateUser(item);
    },
    updateUser(item) {
      let bits = localStorage.getItem("bits");
      this.db
        .collection(process.env.VUE_APP_USER + bits)
        .doc(item.id)
        .update(item.data)
        .then(() => {
          this.$store.dispatch("FLAG_LOADING", false);
        })
        .catch((error) => {
          this.$store.dispatch("FLAG_LOADING", false);
          console.log(error);
        });
    },
    referToInputPickFile() {
      if (this.isAddUser === true) {
        this.$messageError("Tạo nhân viên trước khi chỉnh sửa ảnh");
      } else this.$refs.inputFile.click();
    },
    addImg(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return false;
      } else if (
        files[0].type !== "image/jpeg" &&
        files[0].type !== "image/png" &&
        files[0].type !== "image/jpg"
      ) {
        this.$notify({
          timeout: 3000,
          type: "warning",
          message: "Chỉ cho phép ảnh định dạng jpeg, png hoặc jpg! Thử lại!",
          icon: "add_alert",
          horizontalAlign: "right",
          verticalAlign: "top",
        });
      } else {
        this.isHaveAnyChange = true;
        this.uploadImg(files[0]);
      }
    },
    uploadImg(file) {
      let fileReader = new FileReader();
      let _this = this;
      fileReader.onload = function(event) {
        var imagesRef = _this.storageRef
          .child(file.name)
          .putString(event.target.result, "data_url");
        imagesRef.on(
          "state_changed",
          (snapshot) => {
            var progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            _this.progress = progress;
          },
          (error) => {
            this.$messageError(error.message);
          },
          () => {
            _this.$messageSuccess("Tải ảnh lên thành công");
            _this.storageRef
              .child(file.name)
              .getDownloadURL()
              .then((downloadURL) => {
                _this.form.avatar.url = downloadURL;
                _this.form.avatar.ref = imagesRef.snapshot.ref.location.path_;
              });
          }
        );
      };
      fileReader.readAsDataURL(file);
    },
    smallAlertModalHide(e) {
      this.isHaveAnyChange = true;
      this.isAddProducts = false;
      console.log(e);
      if (e !== "none") {
        this.form.listProductId = e.map((product) => {
          product = product.data.productId;
          return product;
        });
        this.form.listProducts = e.map((item) => {
          item = {
            id: item.data.productId,
            name: item.data.name,
          };
          return item;
        });
      }

      // e.forEach(item => {
      //   let check = false;
      //   if (this.form.listProductId) {
      //     this.form.listProductId.forEach(product => {
      //       if (product === item.data.productId) {
      //         check = true;
      //       }
      //     });
      //   }
      //   if (!check) {
      //     if (this.form.listProductId) {
      //       this.form.listProductId.push(item.data.productId);
      //       this.form.listProducts.push({
      //         id: item.data.productId,
      //         name: item.data.name
      //       });
      //     } else {
      //       this.form.listProductId = [item.data.productId];
      //       this.form.listProducts = [
      //         {
      //           id: item.data.productId,
      //           name: item.data.name
      //         }
      //       ];
      //     }
      //   }
      // });
    },
    removeProduct(item) {
      let index = this.form.listProducts.findIndex((e) => e.id === item.id);
      if (index !== -1) {
        this.isHaveAnyChange = true;
        this.form.listProductId.splice(index, 1);
        this.form.listProducts.splice(index, 1);
      }
    },
    changeRankUser() {
      this.$store.dispatch("FLAG_LOADING", true);
      let bits = localStorage.getItem("bits");
      let changeAffiliateRate = this.functions.httpsCallable(
        process.env.VUE_APP_CHANGE_AFFILIATE_RATE_FUNC + bits
      );
      changeAffiliateRate({
        employeeCode: this.form.employeeCode,
        newRate: this.newRate,
      })
        .then((res) => {
          if ((res.data.success = true)) {
            this.showDialogChangeRank = false;
            this.$messageSuccess("Đã cập nhật dữ liệu");
            this.$store.dispatch("FLAG_LOADING", false);
          } else {
            this.$messageError("Lỗi, xin thử lại");
            this.$store.dispatch("FLAG_LOADING", false);
          }
        })
        .catch((error) => console.log(error));
    },
    confirmChangeRank() {
      Swal.fire({
        title: "Thay đổi hạng Cộng tác viên",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "Xác nhận",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.changeRankUser();
        }
      });
    },
    recharge(amount) {
      this.form.deposit = parseFloat(this.form.deposit) + amount;
    },
    deduct(amount) {
      this.form.deposit = parseFloat(this.form.deposit) - amount;
    },
    submit() {
      this.form.deposit = parseInt(this.form.deposit);
      this.isAddUser ? this.addUser() : this.editUser();
    },
    addUser() {
      // console.log(this.form.permission);
      Swal.fire({
        title: "Thêm nhân viên",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "OK",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("FLAG_LOADING", true);
          this.checkEmail();
        }
      });
    },
    checkEmployeeName() {
      var bits = localStorage.getItem("bits");
      this.db
        .collection(process.env.VUE_APP_USER + bits)
        .where("name", "==", this.form.name)
        .get()
        .then((querySnapshot) => {
          var check = true;
          querySnapshot.forEach((item) => {
            if (item) {
              check = false;
              this.$store.dispatch("FLAG_LOADING", false);
              this.$messageError("Tên tài khoản đã tồn tại");
            }
          });
          if (check) this.addNewUser();
        });
    },
    checkEmployeeCode() {
      var bits = localStorage.getItem("bits");
      this.db
        .collection(process.env.VUE_APP_USER + bits)
        .where("employeeCode", "==", this.form.employeeCode)
        .get()
        .then((querySnapshot) => {
          var check = true;
          querySnapshot.forEach((item) => {
            if (item) {
              this.$store.dispatch("FLAG_LOADING", false);
              this.$messageError("Mã tài khoản đã tồn tại");
              check = false;
            }
          });
          if (check) this.checkEmployeeName();
        });
    },
    checkEmail() {
      this.form.email = this.form.email.toLowerCase();
      let bits = localStorage.getItem("bits");
      this.db
        .collection(process.env.VUE_APP_USER + bits)
        .where("email", "==", this.form.email.toLowerCase())
        .get()
        .then((doc) => {
          var check = true;
          doc.forEach((item) => {
            if (item) {
              this.$store.dispatch("FLAG_LOADING", false);
              this.$messageError("Email đã tồn tại");
              check = false;
            }
          });
          if (check) this.checkEmployeeCode();
        })
        .catch((error) => {
          this.$store.dispatch("FLAG_LOADING", false);
          console.log(error);
        });
    },
    addNewUser() {
      let bits = localStorage.getItem("bits");
      let addNewUser = this.functions.httpsCallable(
        process.env.VUE_APP_ADD_USER_FUNC + bits
      );
      addNewUser({
        name: this.form.name,
        phone: this.form.phone,
        address: this.form.address,
        deposit: this.form.deposit,
        listProductId: this.form.listProductId,
        listProducts: this.form.listProducts,
        employeeCode: this.form.employeeCode,
        email: this.form.email.toLowerCase(),
        permission: this.form.permission,
        password: this.password,
        affiliateRate: this.affiliateRate,
      })
        .then((result) => {
          if (result.success === false) {
            this.$store.dispatch("FLAG_LOADING", false);
            this.$messageError("Có lỗi, Thử lại!");
          } else {
            this.$store.dispatch("FLAG_LOADING", false);
            this.$messageSuccess("Tạo tài khoản thành công");
            this.close(this.form.employeeCode);
          }
        })
        .catch((error) => {
          this.$store.dispatch("FLAG_LOADING", false);
          console.log(error);
          this.$messageError("Có lỗi, Thử lại!");
        });
    },
    editUser() {
      Swal.fire({
        title: "Chỉnh sửa thông tin?",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "OK",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("FLAG_LOADING", true);
          let bits = localStorage.getItem("bits");
          this.form.affiliateRate = parseFloat(this.form.affiliateRate);
          this.db
            .collection(process.env.VUE_APP_USER + bits)
            .doc(this.userSelected.id)
            .update(this.form)
            .then(() => {
              this.$store.dispatch("FLAG_LOADING", false);
              this.$messageSuccess("Thành công!!!");
              this.isHaveAnyChange = false;
            })
            .catch((error) => {
              this.$store.dispatch("FLAG_LOADING", false);
              this.$messageError(error.message);
            });
        }
      });
    },
    close(employeeCode) {
      this.$emit("close", employeeCode);
    },
  },
  watch: {
    userSelected() {
      this.form = this.userSelected.data;
    },
    showDialogChangeRank() {
      if (this.form.permission === "Cộng tác viên") {
        var bits = localStorage.getItem("bits");
        this.db
          .collection("--stats--")
          .doc(process.env.VUE_APP_AFFILIATE_RATES + bits)
          .get()
          .then((doc) => {
            if (doc.exists) {
              this.newRate = doc.data().rates[`${this.form.employeeCode}`];
            }
          });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.icon-add {
  border-radius: 1000px;
  padding: 2px;
  position: absolute;
  top: -10px;
  left: -10px;
  color: rgb(255, 255, 255);
  background: rgba(0, 0, 0, 0.233);
}
.disable-button {
  position: absolute;
  top: 15px;
  right: 20px;
}
.product {
  border: solid rgba(128, 128, 128, 0.315) 0.3px;
  text-align: left;
  padding: 5px;
  max-width: 400px;
  background: rgb(243, 243, 243);
}
.navbar {
  width: 100%;
  background-color: #666;
  overflow: auto;
}

.navbar a {
  float: left;
  padding: 12px;
  color: white;
  text-decoration: none;
  font-size: 17px;
  cursor: pointer;
}

.navbar a:hover {
  background-color: rgba(255, 255, 255, 0.822);
  color: white;
}

.active {
  background-color: #4caf50;
}
.bodyDialog {
  margin: 10px;
  padding: 19px;
}

@media screen and (max-width: 500px) {
  .navbar a {
    float: none;
    display: block;
  }
}
</style>
